<template>
  <el-switch
    v-model="isShow"
    @change="change"
    :active-value="tableData.activeValue"
    :inactive-value="tableData.inactiveValue"
  ></el-switch>
</template>

<script>
export default {
  name: "messageSwitch",
  props: {
    tableData: Object,
    scope: Object
  },
  data() {
    return {
      isShow: this.scope.row[this.tableData.bind]
    };
  },
  watch: {
    "scope.row": {
      deep: true,
      handler() {
        this.isShow = this.scope.row[this.tableData.bind];
      }
    }
  },
  methods: {
    change(e) {
      this.tableData.event && this.tableData.event(this.scope.row, e);
    }
  }
};
</script>

<style scoped></style>
